/* eslint-disable react/prop-types */
import React, {
  createContext, useState, useContext, useMemo,
} from 'react';

const ProfileContext = createContext();

export function ProfileProvider({ children }) {
  const [profile, setProfile] = useState({});

  const contextValue = useMemo(() => ({ profile, setProfile }), [profile]);

  return (
    <ProfileContext.Provider value={contextValue}>
      {children}
    </ProfileContext.Provider>
  );
}

export const useProfile = () => useContext(ProfileContext);
